export enum InvestorShareMarketStatusFilter {
  Watched = 1,
  HaveOrders = 2,
  OwnShares = 3,
}
